import { render, staticRenderFns } from "./AssetMetrics.vue?vue&type=template&id=ba1afd78&"
import script from "./AssetMetrics.vue?vue&type=script&lang=ts&"
export * from "./AssetMetrics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports